import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api/client';
import type { CollectorRunsResponse, SourceKind } from '../api/contracts';

/**
 * GET /api/collector-runs?sourceKind=&limit=
 */
export function useCollectorRuns(sourceKind: SourceKind, limit = 20) {
  return useQuery({
    queryKey: ['collector-runs', sourceKind, limit],
    queryFn: () =>
      apiClient.get<CollectorRunsResponse>(
        `/api/collector-runs?sourceKind=${encodeURIComponent(sourceKind)}&limit=${limit}`,
      ),
  });
}

/**
 * Maps a CollectorRunDto's status to a Cloudscape StatusIndicator `type`.
 * Exported standalone so it's directly unit-testable -- a `failed` run must
 * render distinctly (error styling) from `succeeded`, since a failed run is
 * the earliest signal a collector broke (see docs/PLAN.md).
 */
export function collectorRunStatusIndicatorType(
  status: CollectorRunsResponse['runs'][number]['status'],
): 'error' | 'success' | 'in-progress' {
  switch (status) {
    case 'failed':
      return 'error';
    case 'succeeded':
      return 'success';
    case 'running':
      return 'in-progress';
  }
}
